const prefix = "featured/";

export const _sharedActionsConstantsFeaturedSearch = {
  FETCH_BY_QUERY: prefix + "FETCH",
  FETCH_SUCCESS: prefix + "FETCH_SUCCESS",
  SET_SECTION: prefix + "SET_SECTION",
  FETCH_FOR_PARAGRAPH: prefix + "FETCH_FOR_PARAGRAPH",
};

export const _sharedActionsFeaturedSearch = {
  fetchByQuery: (query, langs) => ({
    type: _sharedActionsConstantsFeaturedSearch.FETCH_BY_QUERY,
    data: { query, langs, },
  }),
  fetchByParaId: (paraId, onSuccess) => ({
    type: _sharedActionsConstantsFeaturedSearch.FETCH_FOR_PARAGRAPH,
    data: { paraId, onSuccess },
  }),
  fetchSuccess: (data, params) => ({
    type: _sharedActionsConstantsFeaturedSearch.FETCH_SUCCESS,
    data: {
      data,
      params,
    },
  }),
  setSection: (sectionNew) => ({
    type: _sharedActionsConstantsFeaturedSearch.SET_SECTION,
    data: sectionNew,
  }),
};
